import { FETCH_LEADERBOARD } from "../actions";

const DEFAULT_STATE = {
  leaderboard: {}
};

const leaderboardReducer = function (state = DEFAULT_STATE, action){
  switch (action.type) {
    case FETCH_LEADERBOARD:
      const data = action.payload;
      return data;
    default:
      return state;
  }
}

export default leaderboardReducer;